import { useFormatter, useTranslations } from "next-intl";

/**
 * Hook that provides a function to format prices with currency.
 * Centralizes the logic for checking if price is 0 (Free) and formatting currency.
 *
 * @returns A function that formats a price with its currency
 */
export function usePriceFormatter() {
  const format = useFormatter();
  const t = useTranslations("PriceFormatter");

  return (price: number, currency: string): string => {
    if (price === 0) {
      return t("free");
    }

    return format.number(price, "currency", {
      currency: currency,
    });
  };
}
